module.exports = __webpack_public_path__ + "static/media/mobilepay-input-light.cd2af32d.svg";